<template>
  <div class="form-group product-type">
    <div class="product-type-title y-center left-padding">
      产品分类
    </div>
    <div class="product-type-content">
      <div v-for="(item,index) in typeItems">
        <div class="y-center detail-type-title" @click="toggle(item,index)">
          <template v-if="item.show==true">
                    <span>
                      <img src="static/imgs/unfold.png" alt="">
                    </span>{{item.className}}
          </template>
          <template v-else>
                    <span>
                      <img src="static/imgs/packUp.png" alt="">
                    </span>{{item.className}}
          </template>
        </div>
        <transition name="fade">
          <div v-show="item.show">

            <div class="y-center detail-type-content left-padding" v-for="(sub,key) in second"
                 v-if="item.id == sub.parentid"
                 @click="filtrate( sub.innercode,key )">
              <span :class="{thisCondition: active == key}">{{sub.className}}</span></div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
  /*eslint-disable*/
  import {apiLinks} from '../api/links'
  import Bus from '../eventbus/bus'
  import EVENTLIST from '../eventbus/eventlist'
  import _ from 'lodash'
  import Vue from 'vue'
  export default {
    name: 'lnav',
    props: {
      // 基础类型检测 （`null` 意思是任何类型都可以）
      switcher: ''
    },
    data () {
      return {
        materialList: [],
        second: [],
        typeItems: [
          {
            show: false,
            title: '',
            content: []
          },
          {
            show: false,
            title: '',
            content: []
          },
          {
            show: false,
            title: '',
            content: ''
          },
          {
            show: false,
            title: '',
            content: ''
          }
        ],
        condition: '',
        active: 99
      }
    },
    mounted () {
      this.fetchMateriaClass()
      Bus.$on(EVENTLIST.TODO_CHANGE, () => {
        this.active = 99
        this.condition = ''
      })
    },
    methods: {
      toggle: function (item, index) {
        item.show = !item.show
        for (let i = 0; i < this.typeItems.length; i++) {
          if (i === index) {
          } else {
            this.typeItems[i].show = false
          }
        }
        Vue.set(this.typeItems, index, item)
        this.generateMaterialTree(1, item)
      },
      generateMaterialTree (level, item) {
        switch (level) {
          case 0:
            // let lv1 = []
            // let list = _.filter(this.materialList, function (data) {
            //   if (data.parentid === 0) {
            //     lv1.push(data.id)
            //   }
            //   data.show = false
            //   if(window.location.href.indexOf('purchase')>0){
            //     return data.parentid === 0&&data.className!='物流服务'
            //   }else if(window.location.href.indexOf('logistics')>0){
            //     return data.parentid === 0&&data.className=='物流服务'
            //   }else{
            //     return data.parentid === 0
            //   }
            // })
            this.typeItems = this.materialList
            break
          case 1:
            this.$http.jsonp(apiLinks.materiaClass+item.id, []).then(function (response) {
              let data = response.body[0]
              this.second = data.data
            }, function (response) {
              console.log(0)
            })
            break
        }
      },
      fetchMateriaClass: function () {
        this.$http.jsonp(apiLinks.materiaClass+0, []).then((response) => {
          let data = response.body[0]
          if (data.status === 1) {
            this.materialList = data.data
            this.generateMaterialTree(0)
          }
        }, function (response) {
          console.log(0)
        })
      },
//      筛选/子组件之间通讯
      filtrate: function (condition, index) {
        if (this.active !== index) {
          this.active = index
          this.condition = condition
        } else {
          this.active = 99
          this.condition = ''
        }
        this.$emit('filtrate')
      }
    }
  }
</script>

<style>
  .product-type-content {
    max-height: 570px;
    color: #666666;
    overflow-y: auto;
  }

  .product-type-content::-webkit-scrollbar {
    width: 10px;
    /* background-color: #F5F5F5; */
  }

  /*滚动条的样式*/
  .product-type-content::-webkit-scrollbar-thumb {
    background-color: #E9E9E9;
    /*background-image: -webkit-gradient(linear, 40% 0%, 75% 84%, from(rgb(77, 156, 65)), color-stop(0.6, rgb(84, 222, 93)), to(rgb(25, 145, 29)));*/
    border-radius: 10px;
  }

  /*轨道的样式*/
  .product-type-content::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    background-color: #F5F5F5;
    /*border-radius: 10px;*/
  }

  /*fade动画效果*/
  /*.fade-enter-active, .fade-leave-active {*/
    /*transition: opacity .5s*/
  /*}*/

  /*.fade-enter, .fade-leave-active {*/
    /*opacity: 0*/
  /*}*/

  .fade-enter-active {
    transition: opacity .5s
  }

  .fade-enter {
    opacity: 0
  }

  .detail-type-content {
    cursor: pointer;
  }

  .thisCondition {
    color: #E84C3D;
    border-bottom: 1px solid #E84C3D;
  }
</style>



// WEBPACK FOOTER //
// L-nav.vue?71e4ea00